import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { forEach } from 'lodash';
import EstimateBuilderHeader from './EstimateBuilderHeader';
import cookiesFactory from './../../../base/cookies-factory';
import saveProductDesignDismiss from '../actions/saveProductDesignDismiss';

const mapDispatchToProps = (dispatch) => {
  const actions = bindActionCreators({ saveProductDesignDismiss }, dispatch);
  return { ...actions, dispatch };
};

const mapStateToProps = ({ estimateBuilder }) => {
  const { uiState, entities: { estimates } } = estimateBuilder;
  const selectedEstimate = uiState && uiState.selectedEstimate;
  const estimate = estimates.byId[selectedEstimate];
  const { attributes: { isMandi, isAutoReleaseDesign } } = estimate;

  const isInternalUser = cookiesFactory.isInternalUser();
  // This looks suspicous
  const { saveProductDesignAlert } = uiState && uiState;

  const autoReleaseDesigns = [];
  const regularDesigns = [];

  forEach(estimates.byId, (item) => {
    if (item.attributes.isAutoReleaseDesign === 'true') {
      autoReleaseDesigns.push(item.designId);
    } else {
      regularDesigns.push(item.designId);
    }
  });

  return {
    designIds: regularDesigns,
    autoReleaseDesigns,
    isMandi,
    isAutoReleaseDesign: isAutoReleaseDesign === 'true',
    isInternalUser,
    saveProductDesignAlert,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EstimateBuilderHeader);
